// extracted by mini-css-extract-plugin
export const cover = "cover-module--cover--2nc9d";